import type { CentPrecisionMoney, Maybe, PrimaryCategory, StyleProduct, Variant } from '../../../../codegen/types';
import { getAmount } from '../../../currencyHelper';
import { sendDataLayerEvent } from '../../utils/dataLayerInteractions';
import EventNamesType from '../eventNamesType';

export type ViewItemDataProp = {
  variants: Variant[];
  actualPrice: Partial<CentPrecisionMoney>;
  productName: string;
  key: string;
  brand?: Maybe<string>;
  primaryCategory?: Maybe<PrimaryCategory>;
  colors?: Maybe<StyleProduct[]>;
  itemListName?: string;
  itemListId?: string;
  wasPrice?: Partial<Maybe<CentPrecisionMoney>>;
  thenPrice?: Partial<Maybe<CentPrecisionMoney>>;
  images: string[];
  slug: string;
};

export const sendViewItemEvent = (productData: ViewItemDataProp, baseUrl: string) => {
  const {
    variants,
    actualPrice,
    productName,
    key,
    brand,
    primaryCategory,
    colors,
    itemListName,
    itemListId,
    wasPrice,
    thenPrice,
    images,
    slug,
  } = productData;

  const discountAmount =
    wasPrice && actualPrice ? +getAmount(wasPrice.centAmount) - +getAmount(actualPrice.centAmount) : 0;
  const url = baseUrl ? `${baseUrl}/${slug}/${key}-p` : undefined;
  const imageUrl = images && images.length > 0 ? images[0] : undefined;

  sendDataLayerEvent(EventNamesType.view_item, {
    ecommerce: {
      currency: variants?.[0]?.price?.[0]?.actualPrice?.currencyCode ?? '',
      value: +getAmount(actualPrice?.centAmount),
      items: [
        {
          index: 0,
          quantity: 1,
          item_name: productName,
          item_id: key ?? '',
          price: +getAmount(actualPrice?.centAmount),
          item_brand: brand ?? 'Clarks',
          item_category: primaryCategory?.name,
          item_category_id: primaryCategory?.key,
          item_variant: colors?.find((color: StyleProduct) => color.key === key)?.color ?? '',
          item_list_name: itemListName || undefined,
          item_list_id: itemListId || undefined,
          discount: +discountAmount.toFixed(2),
          was_price: +getAmount(wasPrice?.centAmount),
          then_price: +getAmount(thenPrice?.centAmount),
          item_url: url,
          item_image_url: imageUrl,
        },
      ],
    },
  });
};
